import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function updateCarService(
  _id: string,
  updateCarService: any
): Promise<any> {
  try {
    const response = await axiosInstance.patch(
      `${config.apiUrl}/car-services/${_id}`,
      updateCarService
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error updating Car Service"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
